import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../../base";

function FormCheckBoxMultiInputPreview({ ...props }) {
  return <BasePreview {...props}>
    <input type="checkbox" />
  </BasePreview>
}

export default define('form-checkbox-multi-input', FormCheckBoxMultiInputPreview, Fragment)
  .shared(prop.share('FormCheckboxMultiInput', 'form-checkbox-multi-input'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .build()

